<template>
  <div class="flex flex-row w-screen">
    <div class="w-full">
      <div
        class="mt-3 mb-3 w-full flex flex-row justify-around content-center"
        id="gallery"
        style="overflow: hidden"
        :key="refreshKey"
      >
        <button class="button my-auto" @click="submit(false)">&laquo;</button>
        <div class="flex flex-row justify-around w-5/6" style="align-items:center">
          <ImageComponent
            v-for="(image, index) in displayArray"
            :key="index"
            class="mx-2"
            style="
              width: 100px;
              height: 100px;
              transition: all 0.5s ease !important;
            "
             :style="
              selectedImageID == image.id
                ? 'border:red 2px solid; height:98px'
                : 'opacity:70%'
            "
            @click="selectedImage(index)"
            :url="image.url + '?session=' + session"
            :imageId="image.id"
            :isSelected="(selectedImageID == image.id)"
          />
        </div>
        <button  v-if="!lastImage" class="button my-auto" @click="submit(true)">&raquo;</button>
        <button v-if="lastImage && showNext" class="flex items-center text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo p-2 m-1" style="height:fit-content;" @click="goToNextPage()">
          <span>Next Page</span>
        </button>
      </div>
      <!-- <transition-group name="slide" mode="out-in">
        <OCRComponent
          :selectedImageID="selectedImageID"
          :key="'stage-1'"
          @loading="setLoader($event)"
          @reset="reset()"
        />
      </transition-group> -->
      <NewOCR ref="OCR" :selectedImageID="selectedImageID" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Http, { OCR_ENDPOINTS } from "../request";
import router from "../router/index";
import ImageComponent from "../components/ImageComponent.vue";
import NewOCR from "../components/NewOCR.vue";
import _ from "lodash";
export default {
  name: "OCRValidation",
  data() {
    return {
      batchId: null,
      session: this.$store.state.id,
      selectedImageID: null,
      size: null,
      images: [],
      displayArray: [],
      refreshKey: 0,
      indices: [],
      lastImage:false,
      showNext:false,
      pageQuery:this.setQuery(),
      nextPagePath:this.$route.query.path?String(this.$route.query.path):''
    };
  },
  components: {
    ImageComponent,
    NewOCR,
  },
  created() {
    this.selectedImageID = String(this.$route.query.selectedImageID);
    this.batchId = this.$route.query.batchId;    
    this.getDisplayImages();
  },

  methods: {
    setQuery(){
      if(this.$route.query){
        return {
          currentPage:this.$route.query.currentPage?this.$route.query.currentPage:'1',
          perPage:this.$route.query.perPage?this.$route.query.perPage:'21',
          selectedFields:this.$route.query.selectedFields?this.$route.query.selectedFields:null,
          sortDirection:this.$route.query.sortDirection?this.$route.query.sortDirection:null,
          sortFilter:this.$route.query.sortFilter?this.$route.query.sortFilter:'creationDate',
          statusFilter:this.$route.query.statusFilter?this.$route.query.statusFilter:null,
        }
      }
    },
    goToNextPage(){
      this.pageQuery.currentPage=parseInt(this.pageQuery.currentPage)+1;
      router.push({
        path: this.nextPagePath,
        query: this.pageQuery,
      });
    },
    getDisplayImages() {
      Http()
        .get(OCR_ENDPOINTS.batches + `${this.batchId}` + "/images", {
          params: {
            size: 99999,
            sortFields: this.pageQuery.sortFilter?[this.pageQuery.sortFilter,"id"]:['id'],
            imageStatus:this.pageQuery.statusFilter?this.pageQuery.statusFilter:null,
            sortDirection:this.pageQuery.sortDirection?this.pageQuery.sortDirection:null,
            page: 0,
            annotatedFields:this.pageQuery.selectedFields?this.pageQuery.selectedFields:null,
          },
          showLoader: false,
        })
        .then((response) => {
          this.images = response.data.images;
          this.size =  response.data.totalImages;
          this.index = this.images.findIndex((image) => {
            return image.id == this.selectedImageID;
          });
          this.setImages();
        })
        .catch((error) => {
          // this.validProject = false;
        })
        .finally(() => {});
    },
    setImages() {
      this.indices = [];
      if(this.pageQuery){
        let lastIndex=(this.pageQuery.perPage*this.pageQuery.currentPage)-1;
        this.showNext=false;
        if(this.index==this.size-1){
          this.lastImage=true;
        }else{
          if(this.index==lastIndex){
            this.lastImage = true;
            if(this.size>this.pageQuery.perPage){
              this.showNext=true;
            }
          }else {
            this.lastImage = false;
            if (this.index < 0) {
              this.index = this.size - 1;
              this.lastImage = true;
              this.showNext=false;
            }
          } 
        }
      }
      this.indices = [this.index];
      this.selectedImageID = String(this.images[this.index].id);
      for (var i = 1; i < 3; i++) {
        if (this.index + i < this.images.length) {
          this.indices.push(this.index + i);
        }
      }
      for (var i = 1; i < 3; i++) {
        if (this.index - i >= 0) {
          this.indices.unshift(this.index - i);
        }
      }
      this.displayArray = [];
      for (var i = 0; i < this.indices.length; i++) {
        this.displayArray[i] = this.images[this.indices[i]];
      }
    },
    setLoader(trigger) {
      this.$parent.loading = trigger;
    },
    reset() {
      this.setLoader(false);
      router.push("main-page-images");
    },
    selectedImage(index) {
      this.index = this.indices[index];
      this.setImages();
      this.refreshKey++;
    },

    submit(ahead) {
      this.$refs.OCR.submitImage(ahead);
    },
    navigate(ahead) {
      if (ahead) {
        this.index++;
      } else {
        this.index--;
      }
      if (this.images[this.index]?.id) {
        let batchId = this.$route.query.batchId;
        router.replace({
          path:
            "/annotation?selectedImageID=" +
            this.images[this.index].id +
            "&batchId=" +
            batchId,
        });
      }
      this.setImages();
      this.refreshKey++;
    },
  },
};
</script>
<style scoped>
.button {
  background-color: gray;
  color: white;
  border-radius: 50%;
  outline: none;
  height: 40px;
  width: 40px;
  transition: all 0.5s;
}

.button:hover {
  background-color: black;
}
</style>
